import type { MarketplaceKey } from "@porsche-customer/slfinrtl-context-types"

export type FinancingProduct = "LEASING" | "THREEWAY_LOAN" | "RENTING" | "LOAN"

export const getFinancingProducts = (key: MarketplaceKey): FinancingProduct[] => {
	switch (key) {
		case "de":
			return ["LEASING", "THREEWAY_LOAN", "LOAN"]
		case "fr":
			return ["LEASING", "THREEWAY_LOAN"]
		case "it":
			return ["LEASING", "RENTING"]
		case "ch":
			return ["LEASING"]
		case "jp":
			return ["LOAN", "THREEWAY_LOAN"]
		default:
			return []
	}
}
